<template>
  <div class="animated fadeIn pb-8 brands">
    <div v-if="!loaded" class="d-flex flex-column align-items-center mt-8 py-6">
      <atom-spinner :animation-duration="1000" :size="80" :color="'#EF6C00'" />
      <p class="primary--text font-weight-bold mt-4">
        در حال بارگذاری اطلاعات...
      </p>
    </div>
    <div v-else>
      <v-card class="common-card">
        <div>
          <h4 class="c-grey">برندها</h4>
        </div>
        <hr class="mt-5" />
        <v-row>
          <v-col cols="12" class="d-none d-md-inline">
            <v-btn
              class="orange-borderedBtn white--text mt-3"
              style="float: left"
              height="48"
              @click="newBrandDialog()"
            >
              <v-icon class="shopPrimary--text me-1"> mdi-plus-box-multiple </v-icon>
              ثبت برند جدید
            </v-btn>
          </v-col>
          <v-col cols="12" class="d-block d-sm-none">
            <v-btn
              class="orange-borderedBtn white--text mt-3"
              style="float: left"
              height="48"
              block
              @click="newBrandDialog()"
            >
              <v-icon class="shopPrimary--text me-1"> mdi-plus-box-multiple </v-icon>
              ثبت برند جدید
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <div class="custom-input mt-3">
              <v-text-field
                outlined
                dense
                label="جستجو در عنوان برند..."
                v-model="filteredTitle"
                color="#EF6C00"
                prepend-inner-icon="$Search"
              >
                <template v-slot:append>
                  <v-icon
                    v-if="filteredTitle.length"
                    class="red--text"
                    @click="filteredTitle = ''"
                    >mdi-close-circle-outline
                  </v-icon>
                </template>
              </v-text-field>
            </div>
          </v-col>
          <v-col cols="12" sm="6">
            <v-switch
              v-model="withOutDescription"
              label="نمایش برندهای فاقد توضیحات"
              @change="descriptionFilter"
              style="float: left; font-size: 12px"
            >
            </v-switch>
          </v-col>
        </v-row>

        <div class="custom-table mt-3">
          <div class="custom-table-vue">
            <v-data-table
              responsive
              show-empty
              :current-page="currentPage"
              :items-per-page="perPage"
              :page.sync="currentPage"
              :items="computedBrands"
              :headers="headers"
              striped
              hide-default-footer
              no-results-text="موردی برای نمایش وجود ندارد!"
              empty-text="رکوردی برای نمایش وجود ندارد."
              no-data-text="no_results_text"

            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:no-data>
                <div
                  style="text-align: center; vertical-align: middle"
                  class="mt-2"
                >
                  <p>موردی جهت نمایش وجود ندارد.</p>
                </div>
              </template>
              <template v-slot:[`item.index`]="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 + perPage * (currentPage - 1) }}
                </div>
              </template>
              <template v-slot:cell="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
<template v-slot:[`item.logo`]="{ item }">
 <div style="vertical-align: middle; text-align: center"><span><a :href="item.logo" target="blank">{{ item.name }}</a></span> </div>
</template>
              <template v-slot:[`item.operation`]="{ item }">
                <div style="vertical-align: middle; text-align: center">
                  <v-btn class="warning white--text" @click="editDialog(item)">
                    <v-icon class="white--text me-1">
                      mdi-pencil-outline
                    </v-icon>
                    ویرایش
                  </v-btn>
                </div>
              </template>
              <template v-slot:[`item.description`]="{ item }">
                <div v-if="item.description.length > 20">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attr }">
                      <span v-on="on" v-bind="attr">
                        {{ item.description.slice(0, 20) }} </span
                      ><span>...</span>
                    </template>
                    <div>
                      <span>
                        {{ item.description }}
                      </span>
                    </div>
                  </v-tooltip>
                </div>
                <div v-else>{{ item.description }}</div>
              </template>
            </v-data-table>
          </div>
          <v-row class="mt-6">
            <v-col>
              <div class="d-flex flex-row">
                <span class="c-grey pt-2">نمایش در هر صفحه</span>
                <div class="ms-3 me-3 number-box">
                  <v-select
                    outlined
                    v-model="perPage"
                    :items="perPageItems"
                    @change="currentPage = 1"
                  >
                  </v-select>
                </div>
              </div>
            </v-col>
            <v-col class="d-flex flex-row">
                    <span class="c-grey pt-2"> برو به صفحه  </span>
                    <div class="ms-3 me-3 number-box">
                      <v-select
                        outlined
                        v-model="whichPage"
                      type="number"
          @change="goToPage()"
          @click="goToPage()"
          :items="computedIndex"

                      ></v-select>
                    </div>
                  </v-col>
            <v-col class="text-sm-center">
              <div>
                <v-pagination
                  v-model="currentPage"
                  prev-icon="$ArrowLeft"
                  next-icon="$ArrowRight"
                  :length="Math.ceil(computedBrands.length / perPage)"
                  :total-visible="5"
                  class="float-sm-end"
                >
                </v-pagination>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card>
      <v-dialog v-model="openEditDialog" width="400">
        <v-card>
          <v-card-title class="white"
            ><v-row>
              <v-col>
                <h4 class="c-grey mb-0 pb-0" style="vertical-align: middle">
                  ویرایش برند
                </h4>
              </v-col>
              <v-col cols="2" class="text-left pt-2">
                <span class="pointer" @click="openEditDialog = false"
                  ><v-icon>$Close</v-icon></span
                >
              </v-col>
            </v-row>
          </v-card-title>
          <hr class="mt-0 pt-0" />
          <v-card-text class="pa-3">
            <v-row>
          <v-col md="6" cols="12" class="pt-0">
            <div
              class="img-box pointer"
              @click="$refs.brandImage.$refs.input.click()"
            >
              <img
                height="150"
                width="150"
                class="img"
                :src="
                  selectedBrand.logo
                    ? selectedBrand.logo
                    : '/no-image.png'
                "
              />
              <v-icon x-large class="img-icon white--text">mdi-camera</v-icon>
              <div class="img-loading" v-if="editBrandImageLoading">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  :size="40"
                ></v-progress-circular>
                <h6 class="mt-4 grey--text text--darken-4">
                  در حال بارگذاری...
                </h6>
              </div>
            </div>
          </v-col>
          <v-col cols="6">

            <div class="mt-16">
              <v-btn
                class="orange-borderedBtn pa-5 mt-8"
                style="width: 100%"
                @click="$refs.editBrandImage.$refs.input.click()"
              >
                <v-icon class="me-2">mdi-camera-outline</v-icon> ویرایش
                تصویر برند</v-btn
              >
              <v-file-input
                v-show="false"
                @change="editBrandImageUpload(editBrandImage)"
                v-model="editBrandImage"
                ref="editBrandImage"
              ></v-file-input>
            </div>
          </v-col>
        </v-row>
        <v-text-field
              v-model="selectedBrand.name"
              outlined
              dense
              label="نام برند"
            >
            </v-text-field>

            <v-textarea
              v-model="selectedBrand.description"
              outlined
              rows="3"
              label="توضیحات"
            >
            </v-textarea>

            <div class="text-left pe-3 pb-4 pt-0">
              <v-btn
                class="green-mainBtn me-3"
                @click="doEditBrand()"
                :disabled="!selectedBrand.name"
              >
                تایید
              </v-btn>
              <v-btn class="red-mainBtn" @click="openEditDialog = false">
                بستن
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="openNewBrandDialog" width="400">
        <v-card>
          <v-card-title class="white"
            ><v-row>
              <v-col>
                <h4 class="c-grey mb-0 pb-0" style="vertical-align: middle">
                  ثبت برند جدید
                </h4>
              </v-col>
              <v-col cols="2" class="text-left pt-2">
                <span class="pointer" @click="cancelNewBrand()"
                  ><v-icon>$Close</v-icon></span
                >
              </v-col>
            </v-row></v-card-title
          >
          <hr class="mt-0 pt-0" />

          <v-card-text class="pa-3">

            <v-row>
          <v-col md="6" cols="12" class="pt-0">
            <div
              class="img-box pointer"
              @click="$refs.brandImage.$refs.input.click()"
            >
              <img
                height="150"
                width="150"
                class="img"
                :src="
                  newBrand.pictureUrl
                    ? newBrand.pictureUrl
                    : '/no-image.png'
                "
              />
              <v-icon x-large class="img-icon white--text">mdi-camera</v-icon>
              <div class="img-loading" v-if="brandImageLoading">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  :size="40"
                ></v-progress-circular>
                <h6 class="mt-4 grey--text text--darken-4">
                  در حال بارگذاری...
                </h6>
              </div>
            </div>
          </v-col>
          <v-col cols="6">

            <div class="mt-16">
              <v-btn
                class="orange-borderedBtn pa-5 mt-8"
                style="width: 100%"
                @click="$refs.brandImage.$refs.input.click()"
              >
                <v-icon class="me-2">mdi-camera-outline</v-icon> بارگذاری
                تصویر برند</v-btn
              >
              <v-file-input
                v-show="false"
                @change="newBrandImageUpload(brandImage)"
                v-model="brandImage"
                ref="brandImage"
              ></v-file-input>
            </div>
          </v-col>
        </v-row>
        <v-text-field
              v-model="newBrand.name"
              outlined
              dense
              label="نام برند"
            >
            </v-text-field>

            <v-textarea
              v-model="newBrand.description"
              outlined
              rows="3"
              label="توضیحات"
            >
            </v-textarea>

            <div class="text-left pe-3 pb-4 pt-0">
              <v-btn class="green-mainBtn me-3" @click="addBrand( )">
                تایید
              </v-btn>
              <v-btn class="red-mainBtn" @click="cancelNewBrand()">
                بستن
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import Axios from "axios";
import { AtomSpinner } from "epic-spinners";

export default {
  components: {
    AtomSpinner,
  },
  data() {
    return {
      whichPage:1,
      loaded: false,
      currentPage: 1,
      perPage: 5,
      deviceType: "",
      filteredTitle: "",
      headers: [
        { value: "index", text: "ردیف", sortable: false },
        { value: "name", text: "عنوان", sortable: false },
        { value: "description", text: "توضیحات", sortable: false },
        { value: "logo", text: "تصویر برند", sortable: false },
        { value: "operation", text: "عملیات", sortable: false },
      ],
      perPageItems: [5, 10, 20],
      selectedBrand: {},
      editingBrand: {},
      openEditDialog: false,
      withOutDescription: false,
      openNewBrandDialog: false,
      newBrand: {},
      brands: [],
      allBrands: [],
      brandImage:{},

    editBrandImage:[],
    editBrandImageLoading:false,
    brandImageLoading:false,
    editMyBrandImage: new Object({
      uploadPercentage: 0,
    }),
    myBrandImage:new Object({
      uploadPercentage: 0,
    }),
    };
  },
  methods: {
    goToPage(){
      this.currentPage=Number(this.whichPage);
    },
    getBrands() {
      Axios.get(this.baseUrl + "/satrapp/shop/brands/list", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("shopToken"),
        },
      })
        .then((res) => {
          if (res.status == 200) {
            this.loaded = true;
            this.brands = res.data;
            this.allBrands = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );

            this.toast(title, "error");
            this.loaded = true;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.loaded = true;
        });
    },
    newBrandImageUpload(file) {
    if (!file) {
      return;
    }
    let sizeMB = file.size / 1024 / 1024;

    if (sizeMB > 5) {
      this.toast(
        "حجم فایل " + file.name + " نباید از 5 مگابایت بیشتر باشد",
        "error"
      );
      return;
    }
    // else if (file.type != "image/jpeg" && file.type != "image/png") {
    //   this.toast("فرمت فایل مورد نظر مجاز نمی‌باشد.", "error");
    //   return;
    // }
    else {
      // NOTE (m-myUpload) to upload files
      this.myBrandImage.showProgress = true;
      this.myBrandImage.variant = "info";
      this.myBrandImage.uploadPercentage = 0;
      this.myBrandImage.isUploaded = false;
      this.myBrandImage.uploadButDisable = true;
      var formData = new FormData();
      formData.append(file.name, file);
      this.brandImageLoading = true;
      Axios.post(this.baseUrl + "/satrapp/shop/brand/draft", formData, {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("shopToken"),
        },
        onUploadProgress: ((progressEvent) => {
          this.myBrandImage.uploadPercentage =
            Math.round((progressEvent.loaded * 100) / progressEvent.total) -
            1;
        }).bind(this),

      })
        .then((d) => {
          if (d.status == 200) {
            this.toast(d.data.message, "success");
            this.brandImageLoading = false;
            this.myBrandImage.isUploaded = true;
            this.myBrandImage.uploadPercentage = 100;
            this.myBrandImage.striped = false;
            this.myBrandImage.variant = "success";
            this.myBrandImage.uploadButDisable = false;
            this.newBrand.pictureId = d.data.id;
            this.newBrand.pictureUrl = d.data.url;

          }
        })
        .catch((err) => {
      
          this.toast(err.response.data, "error");
          this.brandImageLoading = false;
        });
    }
  },
  editBrandImageUpload(file) {
    if (!file) {
      return;
    }
    let sizeMB = file.size / 1024 / 1024;

    if (sizeMB > 5) {
      this.toast(
        "حجم فایل " + file.name + " نباید از 5 مگابایت بیشتر باشد",
        "error"
      );
      return;
    } else if (file.type != "image/jpeg" && file.type != "image/png" && file.type != "image/jpg") {
      this.toast("فرمت فایل مورد نظر مجاز نمی‌باشد.", "error");
      return;
    } else {
      // NOTE (m-myUpload) to upload files
      this.editMyBrandImage.showProgress = true;
      this.editMyBrandImage.variant = "info";
      this.editMyBrandImage.uploadPercentage = 0;
      this.editMyBrandImage.isUploaded = false;
      this.editMyBrandImage.uploadButDisable = true;
      var formData = new FormData();
      formData.append(file.name, file);
      this.editMainImageLoading = true;
      Axios.post(
        this.baseUrl +
          "/satrapp/shop/brand/upload/" +
          this.selectedBrand.id,
        formData,
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
          onUploadProgress: ((progressEvent) => {
            this.editMyBrandImage.uploadPercentage =
              Math.round((progressEvent.loaded * 100) / progressEvent.total) -
              1;
          }).bind(this),
        }
      )
        .then((d) => {
          if (d.status == 200) {
            this.editMyBrandImage.isUploaded = true;
            this.editMyBrandImage.uploadPercentage = 100;
            this.editMyBrandImage.striped = false;
            this.editMyBrandImage.variant = "success";
            this.editMyBrandImage.uploadButDisable = false;
            this.selectedBrand.pictureId = d.data.id;
            this.selectedBrand.logo = d.data.url;
            this.editBrandImageLoading = false;
          }
        })
        .catch((err) => {
    
          this.toast(err.response.data, "error");
          this.editBrandImageLoading = false;
        });
    }
  },
    addBrand() {
      Axios.post(
        this.baseUrl + "/satrapp/shop/brand/new",
        {
          name: this.newBrand.name,
          description: this.newBrand.description,
          logo:this.newBrand.pictureId,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.getBrands();
            this.toast(res.data.message, "success");
            this.newBrand = {};

            this.openNewBrandDialog = false;

          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.openNewBrandDialog = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.openNewBrandDialog = false;
        });
    },
    doEditBrand() {
      Axios.patch(
        this.baseUrl +
          "/satrapp/shop/brand/edit/" +
          this.selectedBrand.id,
        {

          name: this.selectedBrand.name,
          description: this.selectedBrand.description,
          logo:this.selectedBrand.pictureId,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
              this.toast(res.data,'success')
            this.getBrands();
            this.openEditDialog = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");

            this.openEditDialog = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.openEditDialog = false;
        });
    },
    editDialog(item) {
      // this.editingBrand = JSON.parse(JSON.stringify(item));
      this.selectedBrand = JSON.parse(JSON.stringify(item));
      this.openEditDialog = true;
    },
    descriptionFilter() {
      let noDescription;
      if (this.withOutDescription) {
        noDescription = this.brands.filter((x) => x.description == "");
        this.brands = noDescription;
      } else {
        this.brands = this.allBrands;
      }
    },
    newBrandDialog() {
      this.openNewBrandDialog = true;
    },

    cancelNewBrand() {
      this.openNewBrandDialog = false;
      this.newBrand = {};
    },
  },
  mounted() {
    this.getBrands();
  },
  computed: {
    computedBrands() {
      let filtered;
      if (this.filteredTitle.length) {
        filtered = this.brands.filter((x) =>
          x.name.toLowerCase().includes(this.filteredTitle.toLowerCase())
        )
          ? this.brands.filter((x) =>
              x.name.toLowerCase().includes(this.filteredTitle.toLowerCase())
            )
          : "";
      } else {
        filtered = this.brands;
      }
      return filtered;
    },
    computedIndex(){
    let arr=[];
let computedLength=this.computedBrands.length;
let arrLength= Math.ceil(computedLength/this.perPage);
for(let i=1 ; i <= arrLength; i++){
  arr.push(i);
}
return arr;
  },
  },
};
</script>
<style lang="scss">

.brands {
  .custom-input {
    .v-input__slot {
      width: 100% !important;
    }
    .v-input__control {
      flex-direction: row !important;
    }
    .v-text-field .v-input__control,
    .v-text-field fieldset {
      min-height: 45px !important;
      border-color: #EF6C00 !important;
    }
    .v-label:not(.v-label--active) {
      transform: translateY(2px);
    }
  }
}
.v-dialog{
  overflow-x:hidden !important;
}
</style>
